export default "__VITE_ASSET__RSAiZ7L6__"